import { PortfolioReturnsData } from '../chart/portfolioReturnsData';
import { timeUtils } from '@instinet-analytics/core-lib';
import { getItemTimeOrLastItem } from '../../../utils/timeseries/timeSeriesUtils';

const { roundToMinute } = timeUtils;

export interface LegendDataItem {
    bps: number;
    valueChange: number;
}

export interface LegendData {
    total?: LegendDataItem;
    buy?: LegendDataItem;
    sell?: LegendDataItem;
    short?: LegendDataItem;
    index1?: LegendDataItem;
    index2?: LegendDataItem;
}

export function deriveLegendData(
    portfolioReturnsData: PortfolioReturnsData,
    time: number | undefined
): LegendData {
    if (time === undefined && portfolioReturnsData.timeSeries.length > 0) {
        time =
            portfolioReturnsData.timeSeries[
                portfolioReturnsData.timeSeries.length - 1
            ].time;
    }
    if (time === undefined) {
        return {};
    }

    const roundedTime = roundToMinute(time);
    const timeSeriesItem = getItemTimeOrLastItem(
        portfolioReturnsData.timeSeries,
        roundedTime
    );

    if (timeSeriesItem === undefined) {
        return {};
    }

    const totalBps = timeSeriesItem.totalBpsValue;
    const totalValueChange = timeSeriesItem.totalValueChange;
    const total =
        totalBps === undefined
            ? undefined
            : { bps: totalBps!, valueChange: totalValueChange! };

    const buyBps = timeSeriesItem.buyBpsValue;
    const buyValueChange = timeSeriesItem.buyValueChange;
    const buy =
        buyBps === undefined
            ? undefined
            : { bps: buyBps!, valueChange: buyValueChange! };

    const sellBps = timeSeriesItem.sellBpsValue;
    const sellValueChange = timeSeriesItem.sellValueChange;
    const sell =
        sellBps === undefined
            ? undefined
            : { bps: sellBps!, valueChange: sellValueChange! };

    const shortBps = timeSeriesItem.shortBpsValue;
    const shortValueChange = timeSeriesItem.shortValueChange;
    const short =
        shortBps === undefined
            ? undefined
            : { bps: shortBps!, valueChange: shortValueChange! };

    const index1Bps = timeSeriesItem.index1BpsValue;
    const index1ValueChange = timeSeriesItem.index1ValueChange;
    const index1 =
        index1Bps === undefined
            ? undefined
            : { bps: index1Bps!, valueChange: index1ValueChange! };

    const index2Bps = timeSeriesItem.index2BpsValue;
    const index2ValueChange = timeSeriesItem.index2ValueChange;
    const index2 =
        index2Bps === undefined
            ? undefined
            : { bps: index2Bps!, valueChange: index2ValueChange! };

    return { total, buy, sell, short, index1, index2 };
}
